import styled, { css } from 'styled-components'

/** @param {{ currency?: boolean }} props */
const withCurrency = props =>
  props.currency &&
  css`
    justify-content: flex-end;
    font-family: NotoSans;
  `

// ? you have to define your own `grid-template-columns`
const tableGrid = css`
  display: grid;
  grid-auto-columns: 1fr;
  align-items: center;
  justify-items: start;
`

/**
 * @param {ReturnType<typeof css>} moreStyles
 */
export const createTable = moreStyles => ({
  Head: styled.div`
    height: fit-content;
    min-height: 35px;

    position: sticky;
    z-index: 1000;
    top: 0;

    background-color: #404040;

    ${tableGrid}
    ${moreStyles}

    ::-webkit-scrollbar {
      display: none;
    }
  `,
  HeadCell: styled.div`
    width: 100%;
    height: 100%;
    padding: 12px;

    display: flex;
    align-items: center;

    color: #fff;
    font-family: 'Gotham-Medium';
    font-size: 13px;
    line-height: 14px;

    background-color: inherit;
    border-left: 1px solid #dee2e6;

    cursor: pointer;

    &:first-child {
      border: none;
    }
  `,
  Row: styled.div`
    height: 50px;

    user-select: none;
    cursor: pointer;

    ${tableGrid}
    ${moreStyles}

    &:hover > * {
      background-color: rgba(0, 0, 0, 0.05);
    }
  `,
  RowCell: styled.div`
    width: 100%;
    height: inherit;
    padding: 12px;

    display: flex;
    align-items: center;

    color: #333333;
    font-family: 'Gotham';
    font-size: 14px;
    line-height: 15px;

    background-color: #ffffff;
    border-bottom: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;

    ${withCurrency}

    &:last-child {
      border-right: 1px solid #dee2e6;
    }
  `,
  Ellipsis: styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
})

export default createTable(css``)



// WEBPACK FOOTER //
// ./src/lib/components/Table.jsx